<template>
  <div>
    <div class="form-group">
      <label for="class_pass_reset_wday" class="m-b-xxs font-semi">
        Class pass reset day
      </label>
      <select
        id="class_pass_reset_wday"
        v-model.number="resetWday"
        class="form-control"
        style="max-width: 240px"
      >
        <option
          v-for="day in days"
          :key="day.value"
          :value="day.value"
        >
          {{ day.label }}
        </option>
      </select>
      <p class="text-gray-600 m-t-xs m-b-none">
        <small>
          For wrestlers on a class-pass-limited subscription (e.g. "1x/week"), passes expire at 11:59 PM in your team's time zone on this day. New passes for the following week are available immediately after.
        </small>
      </p>
    </div>
    <ladda-button
      @lbClicked="update"
      el-class="btn-primary m-t-sm"
      :loading="updating"
    >
      Save
    </ladda-button>
    <small v-if="error" class="text-danger m-l-sm">{{ errorMessage }}</small>
  </div>
</template>

<script>
import LaddaButton from '../../shared/ladda_button.vue';
import { errorableMix } from './mixins/errorable_mix';

export default {
  name: 'kiosk-check-in-settings',
  components: { LaddaButton },
  mixins: [errorableMix],
  props: {
    initialResetWday: {
      type: Number,
      required: true,
    },
    teamId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      // 0 = Sunday … 6 = Saturday (Ruby Date#wday)
      days: [
        { value: 0, label: 'Sunday' },
        { value: 1, label: 'Monday' },
        { value: 2, label: 'Tuesday' },
        { value: 3, label: 'Wednesday' },
        { value: 4, label: 'Thursday' },
        { value: 5, label: 'Friday' },
        { value: 6, label: 'Saturday' },
      ],
      resetWday: 6,
      updating: false,
    };
  },
  mounted() {
    this.resetWday = this.initialResetWday;
  },
  methods: {
    update: _.throttle(function () {
      if (this.updating) return;

      const vm = this;
      vm.updating = true;
      const url = vm.$apiService.teamUrl(this.teamId);
      const data = {
        team: {
          class_pass_reset_wday: this.resetWday,
        },
      };

      axios.put(url, data)
        .then(() => {
          vm.error = false;
          vm.errorMessage = '';
          vm.$notificationManager.emit('show-toast', 'Class pass reset day saved', true);
          vm.updating = false;
        })
        .catch((error) => {
          vm.updating = false;
          vm.errorMessage = `Error: ${error.toString()}`;
          vm.error = true;
        });
    }, 500),
  },
};
</script>
